
function inCaroussel(mag){
  if(mag.website){
    var websitesee = mag.website.substring(2)
    var website = "<a target = '_blank' href = '"+mag.website+"'><p class='text-center'><em>" + websitesee + "</em></p></a>"
  }else{
    var website = "<br>"
  }
  var html =
    "<h3 class='text-center'>" + mag.nom + "</h3>"+
    "<p class='text-center'>" + mag.adresse + "</p>"+
    "<p class='text-center'>" + mag.cp+" "+mag.ville+ "</p>"+
    "<h3 class='text-center'>" + mag.tel+ "</h3>"+
    website+
      (mag.svgid ?
        "<svg class='icon' viewbox='"+mag.viewbox+"'>"+
          "<use xlink:href='#"+mag.svgid+"'></use>"+
        "</svg>" : '<div class="panneau">'+mag.ville+'</div>')
  return html
}

function extractdepnum(magasins, callback){
  var depnum = [];
  for (var dep in magasins) {
    depnum.push(dep.ord)
  };
  callback(depnum)
}

function button(){
  var btns = $(".btn-dep");
  for (var i = 0; i < btns.length; i++) {
    btns[i].addEventListener("click", function() {
      $(".btn-dep").removeClass("active");
      $(this).addClass("active")
    });
  }
}

function fillCarousel(magInDep){
  $(".carousel-inner").html(
    "<div class='active item'>"+
    inCaroussel(magInDep[0])+
    "</div>"
  )

  if(magInDep.length>1){
    for (var i = 1; i< magInDep.length; i++) {
      $(".carousel-inner").append(
        "<div class='item'>"+
        inCaroussel(magInDep[i])+
        "</div>"
      )
    }
    $(".carousel-control").show()
  }else{
    $(".carousel-control").hide()
  }
}

module.exports = function (data) {
  button();
  var depInitial = "6";
  $(".btn-dep").each(function(){
    if($(this).attr("data-num")===depInitial){
      $(this).addClass("active")
    }
  })
  var magInit = data[depInitial].magasins;
  fillCarousel(magInit);
  $(".btn-dep").on("click",function(){
    var num = $(this).attr("data-num");
    var magInDep = data[num].magasins

    fillCarousel(magInDep)

  })
  return true;
};



//////////////////
// WEBPACK FOOTER
// ./app/pages/index/js/magasins.js
// module id = 12
// module chunks = 0